import { defineComponent as _defineComponent } from 'vue'
import OptimizerIconV2 from '@sh/components/Utils/OptimizerIconV2.ts.vue';
import { AlertStyle, AlertType, IconsV2 } from '@sh/types';
import { computed } from 'vue';

interface Props {
  type: AlertType;
  alertStyle?: AlertStyle;
  title?: string;
  message?: string;
  close?: boolean;
  action?: {
    text: string;
    type: 'button' | 'link';
    href?: string;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Alert.ts',
  props: {
    type: null,
    alertStyle: { default: AlertStyle.fill },
    title: null,
    message: null,
    close: { type: Boolean },
    action: null
  },
  emits: ["onActionClick", "onCloseClick"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onActionClick'): void;
  (e: 'onCloseClick'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { type: AlertType, alertStyle: AlertStyle, title?: string, message?: string, close?: boolean, action?: {
    text: string;
    type: 'button' | 'link';
    href?: string;
  } };



const iconType = computed((): IconsV2 => {
  const typeMap: Record<AlertType, IconsV2> = {
    [AlertType.Success]: 'checkCircle',
    [AlertType.Error]: 'dangerCircle',
    [AlertType.Info]: 'infoCircle',
    [AlertType.Warning]: 'dangerTriangle',
  };
  return typeMap[props.type];
});



return { __sfc: true,props, iconType, emits, OptimizerIconV2 }
}

})